import { CatalogItemScheduleIntervalViewModel } from '@common/model/catalog/item/schedule/interval.view';

export const formatInterval = (interval: CatalogItemScheduleIntervalViewModel): string => {
  return [interval.from, interval.to].map((v) => v.split(':')[0]).join('-');
};
